export const formatTime = (timeString: string) => {
  if (!timeString) return "";
  try {
    // Handle different time formats
    if (timeString.includes("T")) {
      // ISO format like "2024-01-01T10:30:00"
      return new Date(timeString).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      });
    } else if (timeString.includes(":")) {
      // Time only format like "10:30" or "10:30:00"
      return new Date(`2000-01-01T${timeString}`).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      });
    } else {
      return timeString;
    }
  } catch (error) {
    return timeString;
  }
};
